import { navigateTo, useRequestHeaders } from '#app'

export default defineNuxtRouteMiddleware(async () => {
  const headers = useRequestHeaders(['cookie'])

  try {
    const res = await $fetch('/api/demo/jwt', {
      method: 'GET',
      headers: {
        cookie: headers.cookie || '',
      },
    })

    if (!res?.success || !res?.id?.partId) {
      return navigateTo('/id/medlemskort')
    }
  } catch (err) {
    return navigateTo('/id/medlemskort')
  }
})
